import { render, staticRenderFns } from "./OperationConfigKitty.vue?vue&type=template&id=2963a8aa&scoped=true"
import script from "./OperationConfigKitty.vue?vue&type=script&lang=js"
export * from "./OperationConfigKitty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963a8aa",
  null
  
)

export default component.exports